import React from 'react';
import { Button, Modal, Tabs, Upload, message } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CollectionServer, GetMetaProperties, SetMetaProperties, Model, POST, QueryDetail, QueryOrder, errorCatch, getObjectDisplay, updateInPropertiesUUID, updateInArray, useAuth, useMetaContext, deleteInProperties, contextFilterToObject, foreachInProperties, useClipboardContext, clean, Action, GET, QueryParam, POSTFormData, JSXMap } from 'fennec-ui'
import PageLayout from '../../components/PageLayout';
import MDEditor, { commands, EditorContext } from "@uiw/react-md-editor";
import rehypeSanitize from "rehype-sanitize";
import User from '../../../common/User';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
import { UploadOutlined } from '@ant-design/icons';
import YImage from '../../../common/YImage';
import AbstractCollection from '../../../common/AbstractCollection';
import RezultatiPoMeropriyatiu from '../../forms/RezultatiPoMeropriyatiu';

var _ = require('lodash');
const { TabPane } = Tabs;

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function FederationadministratorSettingsRelativeRating(props) {
    const auth = useAuth()
    const meta = useMetaContext()

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;

        if (!obj) { return obj }

        let p = GetMetaProperties(obj)

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])

        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }

        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.type == "object"), {
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("ID", "ASC"),
            ],
            dropdownActions: (value, item, meta, contextObject) => {
                let name = item?.relation?.reference?.object;
                let m = meta[name]

                return [{
                    title: "Создать",
                    form: Model,

                    object: {},

                    // links: true,
                    // links: "inline",
                    // modelActions: (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                    // },
                    // collectionActions: ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                    // },

                    meta: cleanProperties(m, { ...context, contextObject: contextObject }),
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, `/api/query-create/${name}`, { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                },
                ]
            }
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Meropriyatie"), {
            mode: "dialog",
            queryFilter: [
                QueryDetail("collection"),
                // QueryOrder("nachaloSorevnovaniya", "ASC"),
                // QueryOrder("nazvanieMeropriyatiya", "ASC")
            ],
            dropdownActions: undefined,
            relation: {
                uiFilter: () => [
                    {
                        name: "nazvanieMeropriyatiya",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "mestoProvedeniya",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "nachaloSorevnovaniya",
                        type: "date",
                        queryRaw: (filterByKey, item, akey) => {
                            return QueryParam("w-lge-" + akey, filterByKey.format("YYYY-MM-DD"))
                        },
                        sort: true,
                        filter: true,
                        sorted: "ASC",
                        filtered: dayjs(dayjs().year() + "-01-01"),
                    },
                ],
                displayString: (item) => {
                    return dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " +
                        item?.nazvanieMeropriyatiya + ", " +
                        _.get(item, "mestoProvedeniya.name")
                },
                display: (item) => {
                    return (
                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "0px", marginBottom: "0px" }}>
                            <div>
                                <div style={{ width: "79px", height: "79px", overflow: "hidden", borderRadius: "4px" }}>
                                    <YImage item={item} width={79} hidePreview={true} />
                                </div>
                                <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "2px", fontSize: "12px" }}>
                                    <span style={{
                                        marginRight: "5px",
                                        borderRadius: "5px",
                                        backgroundColor: (dayjs().isAfter(item?.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                        color: (dayjs().isAfter(item?.okonchanieSorevnovaniya)) ? "black" : "white",
                                        fontWeight: (dayjs().isAfter(item?.okonchanieSorevnovaniya)) ? "400" : "600",
                                        fontSize: "14px",
                                        boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                        padding: "2px 4px"
                                    }}>{dayjs(item?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                </div>
                            </div>
                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                    <span style={{ fontWeight: "600" }}>
                                        <a href={`/fed/event/${item?.ID}`}>{item?.nazvanieMeropriyatiya}</a>
                                    </span>
                                </div>
                                <div>
                                    г. <span>{item?.mestoProvedeniya?.name}</span>
                                </div>

                                <div style={{ fontSize: "12px" }}>
                                    {(!!item?.isCalcOtnositelniyRating) && <span><i className="fa fa-circle" style={{ color: "#27b327" }}></i> Рассчитан {(item?.dateCalcOtnositelniyRating) && <span>({dayjs(item?.dateCalcOtnositelniyRating).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')})</span>}</span>}
                                    {(!item?.isCalcOtnositelniyRating) && <span><i className="fa fa-circle" style={{ color: "red" }}></i>  Не рассчитан {(item?.dateCalcOtnositelniyRating) && <span></span>}</span>}
                                </div>
                            </div>
                        </div>
                    )
                },
                // display: (item) => {
                //     return (
                //         <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                //             <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                //                 <YImage item={item} width={32} hidePreview={true} />
                //             </div>

                //             <div style={{ flex: "auto", paddingLeft: "7px" }}>
                //                 <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                //                     <span style={{ fontWeight: "600" }}>
                //                         <a href={`/fed/event/${item.ID}`}>{item.nazvanieMeropriyatiya}</a>
                //                     </span>
                //                 </div>
                //                 <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                //                     <span style={{
                //                         marginRight: "5px",
                //                         borderRadius: "5px",
                //                         backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                //                         color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                //                         fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",
                //                         fontSize: "12px",
                //                         boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                //                         padding: "2px 4px"
                //                     }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                //                     <span>{item?.mestoProvedeniya?.name}</span>
                //                 </div>
                //             </div>
                //         </div>
                //     )
                // },
                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                type: "many-one",
            },
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "TantsevalnayaDistsiplina"), {
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("Nazvanie", "ASC"),
            ],
            dropdownActions: undefined
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Kategoriya"), {
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("Nazvanie", "ASC"),
            ],
            dropdownActions: undefined
        })

        p = foreachInProperties(p, n => (n.type == "string" && !n?.db?.size), {
            type: "func",
            render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                return (<MDEditor
                    data-color-mode="light"
                    value={value} onChange={onChange}
                    preview={"edit"}
                    overflow={false}
                />)
            }
        })

        return SetMetaProperties(obj, p)
    }

    const filters = React.useCallback(() => [
        {
            name: "isCalcRelR",
            sort: true,
            filter: true,
            label: "Отображать мероприятия",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: {
                    data: [
                        { ID: 1, name: "Рассчитанные" },
                        { ID: 2, name: "Нерассчитанные" },
                    ]
                },
                type: "many-one",
            },
            queryRaw: (value, item, key) => {
                if (value == 1) {
                    return QueryParam("w-isCalcOtnositelniyRating", "true")
                    
                } else if (value == 2) {
                    return QueryParam("w-isCalcOtnositelniyRating", "false")
                }
                return ""
            },
            filtered: 1,
        },
        {
            label: "Дата начала",
            name: "nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,

            sorted: "DESC",
        },
        {   // Тип мероприятия
            label: "Тип мероприятия",
            name: "tipMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Уровень мероприятия
            label: "Уровень мероприятия",
            name: "urovenMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Место проведения
            label: "Место проведения",
            name: "mestoProvedeniya",
            // filterType: "group",
            display: (o) => (<div>
                <div>{o.name}</div>
                <div style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "12px" }}>{o?.region?.name}</div>
            </div>),
            displayString: (o) => {
                return o.name + " - " + o?.region?.name
            },
            sort: true,
            filter: true,
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("name", "ASC"),
                QueryOrder("region.name", "ASC"),
            ],
        },
    ], []);


    // const FilterFromContextFilter = React.useCallback(() => [
    //     QueryParam("w-nnu-TotalRatingAfterEventMeropriyatie.TantsevalnayaDistsiplina.ID", 0),
    // ], []);

    const [clipboard, setClipboard] = useClipboardContext()
    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <Tabs defaultActiveKey="system-rating-common">
                    <TabPane key="system-rating-events" tab={"Мероприятия"}>
                        <CollectionServer
                            auth={auth}
                            name={"Meropriyatiya"}
                            queryDetail={"model"}
                            filters={filters}
                            // contextFilters={FilterFromContextFilter}

                            mode="list"
                            
                            render={(item, idx) => {
                                return (
                                    <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "0px", marginBottom: "0px" }}>
                                        <div>
                                            <div style={{ width: "79px", height: "79px", overflow: "hidden", borderRadius: "4px" }}>
                                                <YImage item={item} width={79} hidePreview={true} />
                                            </div>
                                            <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "2px", fontSize: "12px" }}>
                                                <span style={{
                                                    marginRight: "5px",
                                                    borderRadius: "5px",
                                                    backgroundColor: (dayjs().isAfter(item?.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                    color: (dayjs().isAfter(item?.okonchanieSorevnovaniya)) ? "black" : "white",
                                                    fontWeight: (dayjs().isAfter(item?.okonchanieSorevnovaniya)) ? "400" : "600",
                                                    fontSize: "14px",
                                                    boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                    padding: "2px 4px"
                                                }}>{dayjs(item?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                            </div>
                                        </div>
                                        <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                <span style={{ fontWeight: "600" }}>
                                                    <a href={`/fed/event/${item?.ID}`}>{item?.nazvanieMeropriyatiya}</a>
                                                </span>
                                            </div>
                                            <div>
                                                г. <span>{item?.mestoProvedeniya?.name}</span>
                                            </div>
            
                                            <div style={{ fontSize: "12px" }}>
                                                {(!!item?.isCalcOtnositelniyRating) && <span><i className="fa fa-circle" style={{ color: "#27b327" }}></i> Рассчитан {(item?.dateCalcOtnositelniyRating) && <span>({dayjs(item?.dateCalcOtnositelniyRating).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')})</span>}</span>}
                                                {(!item?.isCalcOtnositelniyRating) && <span><i className="fa fa-circle" style={{ color: "red" }}></i>  Не рассчитан {(item?.dateCalcOtnositelniyRating) && <span></span>}</span>}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }}


                            linksModelActions={"inline"}
                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions, update, lock, unlock: collectionUnlock }) => {
                                if (name === "Meropriyatiya") {
                                    let a = []

                                    let eventUrlByAdmin = ""
                                    if (item?.organizatorFederatsiyaID) {
                                        eventUrlByAdmin = `/app/federation-administrator/events/${item.ID}`
                                    } else if (item?.organizatorRegionalnoeOtdelenieID) {
                                        eventUrlByAdmin = `/app/local/${item.organizatorRegionalnoeOtdelenieID}/events/${item.ID}`
                                    } else if (item.organizatorMeropriyatiyaID) {
                                        eventUrlByAdmin = `/app/organizer/${item.organizatorMeropriyatiyaID}/events/${item.ID}`
                                    } else if (item.organizatorShkolaID) {
                                        eventUrlByAdmin = `/app/school/${item.organizatorShkolaID}/events/${item.ID}`
                                    }

                                    a.push({
                                        auth: auth,
                                        title: (<a href={eventUrlByAdmin} target='_blank'>Изменить мероприятие</a>),
                                        // action: (values, unlock, close) => {}
                                    })
                                    a.push({
                                        auth: auth,
                                        title: "Результаты",
                                        readonly: true,
                                        noAntForm: true,
                                        titles: {
                                            subheader: <div style={{ paddingBottom: "15px" }}><div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {item?.nazvanieMeropriyatiya} - {dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item, "mestoProvedeniya.name")}
                                            </div></div>
                                        },
                                        modal: {
                                            width: "940px",
                                        },
                                        object: item,
                                        form: RezultatiPoMeropriyatiu,
                                        action: (values, unlock, close, { collection, setCollection }) => { }
                                    })
                                    a.push({
                                        type: "divider"
                                    })
                                    a.push({
                                        auth: auth,

                                        title: (<div>
                                            <div>Рассчитать относительный рейтинг</div>
                                            <div style={{ fontSize: "12px" }}>
                                                {(!!item?.isCalcOtnositelniyRating) && <span><i className="fa fa-circle" style={{ color: "#27b327" }}></i> Рассчитан {(item?.dateCalcOtnositelniyRating) && <span>({dayjs(item?.dateCalcOtnositelniyRating).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')})</span>}</span>}
                                                {(!item?.isCalcOtnositelniyRating) && <span><i className="fa fa-circle" style={{ color: "red" }}></i>  Не рассчитан {(item?.dateCalcOtnositelniyRating) && <span></span>}</span>}
                                            </div>
                                        </div>),
                                        action: (values, unlock, close) => {
                                            lock()
                                            auth.fetch(`/api/rating-event/calc-by-meropriyatie/${item?.ID}`).then(function (res) {
                                                update();

                                                if (res?.errorList?.length) {
                                                    Modal.warning({
                                                        title: <span>Предупреждение!</span>,
                                                        width: "680px",
                                                        content: <div style={{ fontSize: "13px" }}>
                                                            {JSXMap(res.errorList, (item, idx) => {
                                                                return (<div style={{ marginBottom: "5px" }} key={idx}>
                                                                    [{idx + 1}] {item}
                                                                </div>)
                                                            })}</div>,
                                                        okText: 'Закрыть',
                                                    })
                                                }

                                                if (res && res.status === true) {
                                                    message.success('Готово');
                                                } else if (res && res.status === false) {
                                                    message.error(res.message)
                                                }
                                                collectionUnlock(false);
                                            })
                                        }
                                    })
                                    a.push({
                                        auth: auth,
                                        title: (<div>
                                            <div>Отчет по относительному рейтингу</div>
                                        </div>),
                                        action: (values, unlock, close) => {
                                            lock()
                                            auth.fetchFile(`/api/rating-event/report-by-meropriyatie/${item?.ID}`)
                                                .then(async (res) => {
                                                    collectionUnlock(false);
                                                });
                                        }
                                    })

                                    return a
                                }
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                // return actions
                            }}
                        />
                    </TabPane>
                </Tabs>
            </div>
        </PageLayout >
    );
}